import React from "react";
import Modal from "../../../components/Modal";
import { EntregadorNaFila } from "../types";
import { Users, CheckCircle } from "lucide-react";

interface ModalEntregadoresProps {
  isOpen: boolean;
  onClose: () => void;
  entregadores: EntregadorNaFila[];
  onFinalizarDia: (filaId: number) => Promise<void>;
  isFinalizando: boolean;
}

const ModalEntregadores: React.FC<ModalEntregadoresProps> = ({
  isOpen,
  onClose,
  entregadores,
  onFinalizarDia,
  isFinalizando,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Entregadores Aguardando">
      <div className="space-y-4">
        <p className="text-sm text-neutral-600">
          Finalize o dia dos entregadores que estão aguardando na fila.
        </p>

        {entregadores.length === 0 ? (
          <div className="rounded-lg border-2 border-dashed border-neutral-200 bg-neutral-50 py-12 text-center">
            <Users size={48} className="mx-auto mb-4 text-neutral-400" />
            <p className="text-neutral-500">
              Nenhum entregador com status aguardando
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            {entregadores.map((entregador) => (
              <div
                key={entregador.id}
                className="flex items-center justify-between rounded-lg border border-neutral-200 bg-neutral-50 p-4"
              >
                <div>
                  <p className="font-semibold text-neutral-900">
                    {entregador.nome} {entregador.sobrenome}
                  </p>
                  <p className="text-xs text-neutral-500">
                    Posição {entregador.posicao} na fila ·{" "}
                    {entregador.quantidadeEntregasFinalizadas}{" "}
                    {entregador.quantidadeEntregasFinalizadas === 1
                      ? "entrega finalizada"
                      : "entregas finalizadas"}
                  </p>
                </div>
                <button
                  onClick={() =>
                    onFinalizarDia(entregador.filaId ?? entregador.id)
                  }
                  disabled={isFinalizando}
                  className="flex items-center gap-2 rounded-lg bg-warning px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-warning-dark disabled:cursor-not-allowed disabled:opacity-50"
                >
                  <CheckCircle size={16} />
                  {isFinalizando ? "Finalizando..." : "Finalizar Dia"}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalEntregadores;
